import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateDiscountPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.updateDiscountPerk,
  {
    mutationKey: ['updateDiscountPerk'],
  },
)
